import type { ReactNode } from "react";

interface GateCardProps {
  title: string;
  children: ReactNode;
  /** Set on wide screens (the pending screen carries a form). */
  wide?: boolean;
}

/**
 * The single card shown before the console itself: sign in, wait, or stop.
 *
 * It carries the real product mark and name, because it is the first thing a
 * brand-new researcher sees and it has to say where they are.
 *
 * Args:
 *     title: The card heading, rendered as the page's `h1`.
 *     children: Body of the card.
 *     wide: Roomier layout, for a card that carries a form.
 *
 * Returns:
 *     A centred card filling the viewport.
 */
export function GateCard({ title, children, wide = false }: GateCardProps): JSX.Element {
  return (
    <main className="gate">
      <div className={`gate__card${wide ? " gate__card--wide" : ""}`}>
        <p className="gate__brand">
          {/* Two cuts of the same mark: its colour lives inside the image,
              where `light-dark()` cannot reach, so the stylesheet shows the
              one the palette needs and hides the other. */}
          <img
            className="gate__logo gate__logo--light"
            src="/brand/logomark-purple.svg"
            width={38}
            height={21}
            alt="Neuralk"
          />
          <img
            className="gate__logo gate__logo--dark"
            src="/brand/logomark-white.svg"
            width={38}
            height={21}
            alt="Neuralk"
          />
          <span className="eyebrow">Neuralk Research · GPU Console</span>
        </p>
        <h1 className="gate__title">{title}</h1>
        {children}
      </div>
    </main>
  );
}
